import { z } from 'zod';

export const SRegisterResponse = z.object({
  success: z.string(),
  csrftoken: z.string(),
});
export type TRegisterResponse = z.infer<typeof SRegisterResponse>;

export const SVerifyOTPResponse = z.object({
  message: z.string(),
});
export type TVerifyOTPResponse = z.infer<typeof SVerifyOTPResponse>;

export const SLoginResponse = z.object({
  csrftoken: z.string(),
  refresh: z.string(),
  access: z.string(),
});
export type TLoginResponse = z.infer<typeof SLoginResponse>;

export const SForgptPassResponse = z.object({
  success: z.string(),
  csrftoken: z.string(),
  user: z.string(),
  secretToken: z.string(),
});
export type TForgotPassResponse = z.infer<typeof SForgptPassResponse>;
